import type { CategoryId } from "~/const/categories";
import { CATEGORIES, CATEGORY_IDS } from "~/const/categories";

const POPULAR_CATEGORIES_IDS: CategoryId[] = [
  CATEGORY_IDS.SPECIAL,
  CATEGORY_IDS.ANIME,
  CATEGORY_IDS.STAGE,
  CATEGORY_IDS.MOVIE,
  CATEGORY_IDS.DMM_TV_ORIGINAL,
];

/**
 * 検索履歴：ビデオ人気カテゴリ
 */
export const POPULAR_CATEGORIES = [...CATEGORIES.filter((item) => POPULAR_CATEGORIES_IDS.includes(item.id))];
